import { AutogenModelBatchControlLookup, AutogenRowBatchControlLookup } from "./autogen/AutogenModelBatchControlLookup";

export class ModelBatchControlLookup extends AutogenModelBatchControlLookup<RowBatchControlLookup> {
	constructor() {
		super(RowBatchControlLookup);
	}
}

export class RowBatchControlLookup extends AutogenRowBatchControlLookup {
}